export class EquipmentFilter {
    public CustomerNumber?: string;
    public CustomerNameStartsWith?: string;
    public SalesOfficeCode?: string;
    public SerialNumber?: string;
    public ManufacturerSerialNumber?: string;
    public EquipmentNumber?: string;
    public IncludeRelatedEquipmentRequests?: boolean;
    public RequestID?: number;
    public Take?: number;
}

export default EquipmentFilter;